import React from "react";
import {AccountInfo} from "@azure/msal-browser";


/* eslint import/no-webpack-loader-syntax: off */
import SignInWithMicrosoftLight from "!file-loader!../../images/sign_in_with_microsoft_light.svg"

interface SignedInCheckProps
{
    user: AccountInfo | undefined; 
    signIn: () => void;
    
    children: () => any;
}

export default function SignedInCheck(props: SignedInCheckProps)
{
    if (props.user === undefined)
    {
        return (
            <div className="cdb-sign-in-page">
                <h1>Sign in to Cloud Design Box</h1>
                <p>To access this page, sign in with your Microsoft Account</p>


                <img className={"clickable"} src={SignInWithMicrosoftLight} onClick={() => {
                    props.signIn();
                }}/>
            </div>
        );
    }
    else
    {
        return props.children();
    }    
}